export default __webpack_public_path__ + "static/c03-7de868f7160777778faeab19a5ab8ff8.png";